import React, { useCallback } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";
import List from "../WagerTypeList";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";

function WagerTypes(props) {
  let IdProfile = props.Profile.IdProfile;

  const [wagerType, setWagerType] = React.useState(null);

  const itemSelected = useCallback((item) => {
    setWagerType(item);
  }, []);

  const { values: languages } = useDataFormatterHook({
    value: "idLanguage",
    text: "langDesc",
    path: "/User/GetLanguages",
  });

  return (
    <div className="flex flex-row gap-4">
      <List
        title="Wager Types"
        itemKey="idWagerType"
        getUrl={`/Profile/WagerType_GetList?idProfile=${IdProfile}`}
        itemSelected={itemSelected}
      >
        <TableHeaderColumn
          visible="none"
          hiddenOnInsert
          autoValue={true}
          hidden
          isKey
          dataField="idWagerType"
        >
          IdWagerType
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="description"
          filter={{ type: "TextFilter", delay: 1000 }}
        >
          Description
        </TableHeaderColumn>
      </List>

      <Crud
        className="flex-1"
        title="Language"
        getUrl={wagerType ? () =>
          `/Profile/WagerTypeLang_GetList?idWagerType=${wagerType.idWagerType}`
        : null}
        getProcess={(data) =>
          data.map((item) => ({
            IdComposed: `${item.idWagerType ?? item.IdWagerType}-${item.idLanguage ?? item.IdLanguage}`,
            ...item,
          }))
        }
        // INSERT
        insertUrl={() => "/Profile/WagerTypeLang_Insert"}
        insertParams={({ userId }, { idLanguage, description, IdLanguage, Description }) => ({
          IdWagerType: wagerType?.idWagerType,
          IdLanguage: Number(idLanguage ?? IdLanguage),
          Description: description ?? Description,
          IdUser: Number(userId),
        })}
        // UPDATE
        updateUrl={() => "/Profile/WagerTypeLang_Update"}
        updateParams={({ userId }, { idWagerType, idLanguage, description, IdWagerType, IdLanguage, Description }) => ({
          IdWagerType: idWagerType ?? IdWagerType,
          IdLanguage: Number(idLanguage ?? IdLanguage),
          Description: description ?? Description,
          IdUser: Number(userId),
        })}
        // DELETE
        deleteUrl={() => "/Profile/WagerTypeLang_Delete"}
        deleteParams={({ userId }, _, { idWagerType, idLanguage, IdWagerType, IdLanguage }) => ({
          IdWagerType: idWagerType ?? IdWagerType,
          IdLanguage: Number(idLanguage ?? IdLanguage),
          IdUser: Number(userId),
        })}
      >
        <TableHeaderColumn
          visible="none"
          hiddenOnInsert
          autoValue={true}
          hidden
          isKey
          dataField="IdComposed"
        >
          IdComposed
        </TableHeaderColumn>
        <TableHeaderColumn
          visible="none"
          hiddenOnInsert
          autoValue={true}
          hidden
          dataField="idWagerType"
        >
          IdWagerType
        </TableHeaderColumn>
        <TableHeaderColumn
          hidden
          dataField="idLanguage"
          editable={{ type: "select", options: { values: languages } }}
        >
          Language
        </TableHeaderColumn>
        <TableHeaderColumn hiddenOnInsert editable={false} autoValue={true} dataField="langDesc">
          Language
        </TableHeaderColumn>
        <TableHeaderColumn dataField="description">
          Description
        </TableHeaderColumn>
      </Crud>
    </div>
  );
}

export default WagerTypes;
